import { Log } from './log';

export class FormHelper {

    public static isValidPassword(password: string) : boolean {
    
        if (!password || password.length < 8) {
            Log.debug("invalid password");
            return false;
        }
        return true;
    }

    public static isValidEmail(email: string) : boolean {
    
        if (!email || email.length < 3) {
            Log.debug("invalid email");
            return false;
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}
  